import { API_FEE_PATH, API_HOST_NAME } from '../../env.js';
import { GET_REQUEST, POST_REQUEST } from '@helpers/request.js';
import { urlUtils } from '@helpers/urlUtils.js';

const FEE_ROOT = API_HOST_NAME + API_FEE_PATH;
const structurePaths = {
  listLove: FEE_ROOT + '/get-list-lov',
  searchReceipt: FEE_ROOT + '/search-receipt',
  receiptDetail: FEE_ROOT + '/view-receipt/:receiptId',
  validAgent: FEE_ROOT + '/valid-agent/:agentCode',
  getDebtByPolicyOrAppNo: FEE_ROOT + '/getDebtByPolicyOrAppNo',
  getDebtByPolicyForRenewalPrem: FEE_ROOT + '/getDebtByPolicyForRenewalPrem',
  saveReceipt: FEE_ROOT + '/save-receipt',
  cancelReceipt: FEE_ROOT + '/cancel-receipt',
};

export const getListLoveService = ({ types }) => {
  return GET_REQUEST(structurePaths.listLove, {
    types: types?.join(',') || '',
  });
};

export const getSearchReceiptService = ({ page, size, data }) => {
  return POST_REQUEST(
    urlUtils.buildFullPath(structurePaths.searchReceipt, { page, size }),
    data,
  );
};

export const getReceiptDetailService = ({ receiptId }) => {
  return GET_REQUEST(
    structurePaths.receiptDetail.replace(':receiptId', receiptId),
    {},
  );
};

export const getValidAgentService = ({ agentCode }) => {
  return GET_REQUEST(
    structurePaths.validAgent.replace(':agentCode', agentCode),
    {},
  );
};

export const getDebtByPolicyOrAppNoService = ({ requestKey }) => {
  return GET_REQUEST(structurePaths.getDebtByPolicyOrAppNo, { requestKey });
};

export const getDebtByPolicyForRenewalPremService = ({ policyId }) => {
  return GET_REQUEST(structurePaths.getDebtByPolicyForRenewalPrem, {
    policyId,
  });
};

export const saveReceiptService = (data) => {
  return POST_REQUEST(structurePaths.saveReceipt, data);
};

export const cancelReceiptService = (data) => {
  return POST_REQUEST(structurePaths.cancelReceipt, data);
};
